"use client";

import { cartSchema } from "../../../lib/types/schema/subscription/cartSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { useSession } from "../../../session/hooks/useSession";
import { keyPublicCart } from "./keyCart";

type PublicCartProps = UseRequestQueryProps & {
  priceId?: string;
  promoCode?: string;
};

export const useRequestPublicCart = ({
  priceId,
  promoCode,
  ...props
}: PublicCartProps) => {
  const { status } = useSession();
  return {
    query: useRequestQuery({
      enabledWithoutSessionToken: true,
      enabled:
        typeof priceId === "string" &&
        priceId.length > 0 &&
        status !== "authenticated",
      queryFnRequestProps: {
        schema: cartSchema,
        urlBackendPath: `/public/cart?price_id=${priceId ?? ""}${promoCode ? `&promo_code=${promoCode}` : ""}`,
        requestType: "other",
      },
      queryKey: keyPublicCart({ priceId, promoCode }),
      ...props,
    }),
  };
};
